import { ApiService } from 'react-angle-dashboard-components'
import { DateHandler } from '@angle/utils'
import { currencyFormatter } from '@angle/utils'

const getName = (firstName: any, lastName: any) => {
  if (!firstName && !lastName) return '-'
  else return firstName + ' ' + lastName
}
export interface GetClaimsByMemberReqBody {
  provider_id: string
  // angle_id == member ID
  angle_id: string
  date_of_birth: string
  billed_amount: number
  date_of_service?: string
  first_name?: string
  last_name?: string
}

export interface GetClaimsByNumberReqBody {
  provider_id: string
  claim_number: string
}

// api requirements:
// one of email_contact OR fax_contact
// one of claim_criteria OR claim_search_criteria
export interface CreateTicketReqBody {
  contact?: {
    email?: string
    fax?: string
    phone?: string
  }
  criteria?: GetClaimsByMemberReqBody | GetClaimsByNumberReqBody
  issueContext?: string
  requestor_name: string
}

export interface CreateNoResultTicketReqBody {
  contact?: {
    email?: string
    fax?: string
    phone?: string
  }
  criteria?: GetClaimsByMemberReqBody | GetClaimsByNumberReqBody
  issueContext?: string

  angle_id?: string
  provider_id?: string
  first_name?: string
  last_name?: string
  date_of_birth?: string
  date_of_service?: string
  provider_name?: string
  provider_contact?: string
  provider_phone?: string
  provider_email?: string
  billed_amount?: number
}

export interface ClaimResult {
  claimId: string
  claimNumber: string
  anglePaidStatus: string
  dateOfService: string
  memberResponsibility: string
  anglePaidAmount: string
  networkSavings: string
  billedAmount: string
  allowedAmount: string
  sentAddress: string
  checkNumber: any
  memberName: string
  memberId: string
  patientAccountNumber: string
  paidDate: string
}

const mapClaimsToList = (claims: any) => {
  return claims.map((claim: any) => {
    const { street_1, street_2, city, state, zip } =
      claim.billing_address?.address
    const mappedClaim: ClaimResult = {
      claimId: String(claim.claim_id),
      claimNumber: claim.claim_number,
      anglePaidStatus: claim.angle_paid === true ? 'Completed' : 'In Progress',
      dateOfService: DateHandler.formatForClient(claim.service_date),
      memberResponsibility: claim.patient_amount === "Pending" ? claim.patient_amount : currencyFormatter.format(claim.patient_amount),
      anglePaidAmount: claim.paid_amount === "Pending" ? claim.paid_amount : currencyFormatter.format(claim.paid_amount),
      networkSavings: claim.saved_amount === "Pending" ? claim.saved_amount : currencyFormatter.format(claim.saved_amount),
      billedAmount: currencyFormatter.format(claim.billed_price),
      allowedAmount: claim.plan_price === "Pending" ? claim.plan_price : currencyFormatter.format(claim.plan_price),
      sentAddress: `${street_1 || ''}${street_2 ? ` ${street_2}` : ''}, ${
        city || ''
      } ${state || ''}, ${zip || ''}`,
      memberName: getName(
        claim.member?.name?.first_name,
        claim.member?.name?.last_name
      ),
      memberId: claim.member?.member_id,
      patientAccountNumber: claim.patient_account,
      checkNumber: claim.check_number,
      paidDate: claim.paid_date
    }
    return mappedClaim
  })
}

export class ClaimsService extends ApiService {
  async getClaimsByMember(
    data: GetClaimsByMemberReqBody
  ): Promise<ClaimResult[]> {
    return this.request({
      method: 'post',
      url: '/claim_search/v0/search',
      data
    }).then((r: any) => mapClaimsToList(r))
  }

  async getClaimsByClaimNumber(
    data: GetClaimsByNumberReqBody
  ): Promise<ClaimResult[]> {
    return this.request({
      method: 'post',
      url: '/claim_search/v0/claim',
      data
    }).then((r: any) => mapClaimsToList(r))
  }

  async createTicket(data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: '/claim_search/v0/create_ticket',
      headers: {
        'Content-Type':
          'multipart/form-data; boundary=20639c8395c2a499779e9ec7758bbbe6'
      },
      data
    })
  }

  async createNoResultTicket(data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: '/claim_search/v0/create_ticket/unsuccessful_search',
      headers: {
        'Content-Type':
          'multipart/form-data; boundary=20639c8395c2a499779e9ec7758bbbe6'
      },
      data
    })
  }
}
